// extracted by mini-css-extract-plugin
export default {"tableHeader":"PacientePruebasAlergia_tableHeader__TiSPO","panelNoHeader":"PacientePruebasAlergia_panelNoHeader__GYBPN","panelSection":"PacientePruebasAlergia_panelSection__Jh7DB"};